import { render, staticRenderFns } from "./CreateVehicle.vue?vue&type=template&id=5929131c&lang=pug&"
import script from "./CreateVehicle.vue?vue&type=script&lang=ts&"
export * from "./CreateVehicle.vue?vue&type=script&lang=ts&"
import style0 from "./CreateVehicle.vue?vue&type=style&index=0&id=5929131c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports